import { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

import DataTable from "react-data-table-component";

import HeaderDashboard from "../../Components/HeaderDashboard";
import $, { param } from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider"
import { flightTransactionReport } from "../../Services/ReservationsApi";
import { GetOrganizationsType } from "../../Services/API"
import { GetAllOrganizations } from "../../Services/API"
import { GetAllCompany } from "../../Services/API"
import { GetAllLegalEntity } from "../../Services/API"

const AllTransactions = () => {
    const { name, userName, roles, corporateId } = useContext(AuthContext);
    const userRole = roles?.[0];


    const tableWrapperRef = useRef(null);

    const [visibleColumns, setVisibleColumns] = useState([]);
    const [hiddenColumns, setHiddenColumns] = useState([]);

    const isTmcAdmin = roles?.includes("TMC Operations");
    const isCorpTravel = roles?.includes("Corporate Traveller");
    const [organizationsType, setOrganizationsType] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [company, setCompany] = useState([]);
    const [legalEntity, setLegalEntity] = useState([]);
    const [hideCompany, setHideCompany] = useState(false);
    const [hidelegalEntity, setHidelegalEntity] = useState(false);

    const [filters, setFilters] = useState({
        organization: "",
        company: "",
        legalEntity: "",
        corporateTraveller: "",
        fromDate: "",
        toDate: "",
        pnr: "",
        transactionId: "",
        bookingRefNo: "",
        paymentStatus: "",
        bookingStatus: "",
    });
    // const userRole = localStorage.getItem("userRole");
    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);

    const hasCalled = useRef(false);
    useEffect(() => {

        setHideCompany(true);
        setHidelegalEntity(true);
        if (corporateId) {
            if (hasCalled.current) return;
            hasCalled.current = true;
            GetOrganizations();
        }
    }, [corporateId]);


    const GetOrganizations = async () => {
        setLoading(true);
        try {
            const res = await GetAllOrganizations();
            setOrganizations(res?.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        if (!filters.organization) {
            setHideCompany(true);
            setHidelegalEntity(true);
            return;
        }

        const organizationCode = filters.organization.split('~')[0];
        const organizationType = filters.organization.split('~')[1];
        const requestBody = {
            corporateCode: organizationCode,
            corporateType: organizationType,
        };
        if (organizationType == "Organization") {
            GetCompanyByOrganization(requestBody);
            setHideCompany(false);
            setHidelegalEntity(true);
        }
        else if (organizationType == "Company") {
            setHidelegalEntity(false);
            setHideCompany(true);
            const request = {
                companyCode: organizationCode,
            };
            GetLegalEntityByCompany(request);
        } else {
            setHideCompany(true);
            setHidelegalEntity(true);
        }

    }, [filters.organization]);

    const GetCompanyByOrganization = async (requestBody) => {
        try {
            setLoading(true);
            const res = await GetAllCompany(requestBody);
            console.log("Company Response:", res);
            setCompany(res?.data ?? []);

        } catch (error) {
            console.error("Company fetch error:", error);
            alert(error?.message || "Error fetching company");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleSearch();
        if (filters.company) {
            const companyCode = filters.company.split('~')[0];
            //const organizationType = filters.company.split('~')[1];

            setHidelegalEntity(false);
            const requestBody = {
                companyCode: companyCode,
            };
            GetLegalEntityByCompany(requestBody);
        }
    }, [filters.company]);

    const GetLegalEntityByCompany = async (requestBody) => {

        try {
            setLoading(true);
            const res = await GetAllLegalEntity(requestBody);
            console.log("Legal Entity Response:", res);
            setLegalEntity(res?.data ?? []);

        } catch (error) {
            console.error("Legal Entity error:", error);
            alert(error?.message || "Error fetching Legal Entity");
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                Organization: filters.organization?.split('~')[0],
                Company: filters.company?.split('~')[0],
                legalEntity: filters.legalEntity?.split('~')[0],
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                GDSPNR: filters.pnr,
                TrackID: filters.transactionId,
                ReferenceNo: filters.bookingRefNo,
                PaymentStatus: filters.paymentStatus,
                BookingStatus: filters.bookingStatus,
                UserName: userName,
            };
            console.log("requestBody", requestBody);

            const data = await flightTransactionReport(requestBody);
            console.log("data", data);
            const all = data?.allTransactions;
            const list = data?.allTransactions?.airTransactionResponse || [];
            setTransactions(list);

            setSummary({
                paymentSuccessCount: all?.paymentSuccessCount || 0,
                paymentRequestedCount: all?.paymentRequestedCount || 0,
                paymentFailedCount: all?.paymentFailedCount || 0,
                bookingSuccessCount: all?.bookingSuccessCount || 0,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    // data table start


    const [filterText, setFilterText] = useState("");



    const filteredItems = transactions.filter(
        (item) =>
            item.referenceNo?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.paxName?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.gdspnr?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.sector?.toLowerCase().includes(filterText.toLowerCase())
    );
    const customStyles = {
        table: {
            style: {
                backgroundColor: "#fff",
                borderRadius: "0px",
                overflow: "hidden",
            },
        },
        headRow: {
            style: {
                background: "#110942",
                minHeight: "55px",
                borderBottomWidth: "0",
            },
        },
        headCells: {
            style: {
                color: "#fff",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "60px",
                fontSize: "14px",
                borderBottom: "1px solid #eef2f7",
                '&:hover': {
                    backgroundColor: "#f4f8ff",
                    cursor: "pointer",
                },
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #eef2f7",
                minHeight: "60px",
            },
        },
    };
    const StatusBadge = ({ status }) => {
        let bg = "#ffe5e5";
        let color = "#ff1f1f";

        if (
            status === "Success" ||
            status === "Confirmed"
        ) {
            bg = "#e7f8ec";
            color = "#00a63e";
        }

        if (status === "Hold") {
            bg = "#fff3d6";
            color = "#ff9800";
        }

        return (
            <span
                style={{
                    background: bg,
                    color: color,
                    padding: "6px 10px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "inline-block",
                    minWidth: "95px",
                    textAlign: "center",
                }}
            >
                {status}
            </span>
        );
    };
    const allColumns = [
        {
            id: "referenceNo",
            name: "Ref No.",
            selector: row => row.referenceNo,
            sortable: true,
            cell: row => (
                <span
                    title="Details"
                    style={{
                        fontWeight: 700,
                        color: "#0d47a1",
                        cursor: "pointer",
                    }}
                    onClick={() =>
                        navigate(
                            `/Reservations/Flight/TransactionDetails?referenceNo=${row.referenceNo}&trackID=${row.trackID}`
                        )
                    }
                >
                    {row.referenceNo}
                </span>
            ),

            priority: 1,
        },

        ...(!isCorpTravel ? [
            {
                id: "organization",
                name: "Entity Name",
                selector: row => row.agencyName,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.agencyName} ({row.agentName})
                    </>
                ),
                priority: 2,
            },
            {
                id: "paxName",
                name: "Pax Name",
                selector: row => row.paxName,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.paxName}
                    </>
                ),
                priority: 3,
            }
        ] : []),

        {
            id: "bookingDate",
            name: "Booking Date",
            selector: row => row.insertedOn,
            sortable: true,
            priority: 4,
            grow: 2,
            cell: row => (
                <>
                    {row.insertedOn}
                </>
            )
        },

        {
            id: "sector",
            name: "Route",
            selector: row => row.sector,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.sector}
                </>
            ),
            priority: 5,
        },

        {
            id: "travelDate",
            name: "Travel Date",
            selector: row => row.departureDate,
            sortable: true,
            priority: 6,
            grow: 2,
            cell: row => {
                const formatDate = (dateString) => {
                    if (!dateString) return "-";

                    const date = new Date(dateString);
                    if (isNaN(date.getTime())) return "-";

                    // Format: "05 Aug 2026 15:20"
                    return date.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }).replace(/,/g, '');
                };

                return (
                    <>
                        {formatDate(row.departureDate)}
                    </>
                );
            }
        },

        {
            id: "Airline",
            name: "Airline",
            selector: row => row.airlineName || "-",
            sortable: true,
            priority: 7,
        },

        {
            id: "pnr",
            name: "PNR",
            selector: row => row.gdspnr || "-",
            sortable: true,
            priority: 7,
        },

        {
            id: "paymentStatus",
            name: "Payment",
            selector: row => row.paymentStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.paymentStatus} />
            ),
            priority: 9,
        },

        {
            id: "bookingStatus",
            name: "Booking ",
            selector: row => row.bookingStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.bookingStatus} />
            ),
            priority: 10,
        },

        {
            id: "ticketStatus",
            name: "Ticket Status",
            selector: row => row.ticketingStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.ticketingStatus} />
            ),
            priority: 11,
        },

        {
            id: "fare",
            name: "Amount",
            selector: row => row.totalFare,
            sortable: true,
            //right: true,
            cell: row => (
                <span
                    style={{
                        fontWeight: 600,
                        color: "#263238",
                    }}
                >
                    ₹ {Number(row.totalFare).toLocaleString("en-IN")}
                </span>
            ),
            priority: 12,
        },
    ];

    const calculateResponsiveColumns = () => {
        if (!tableWrapperRef.current) return;

        const containerWidth =
            tableWrapperRef.current.clientWidth;

        // Width required for + button
        const expanderWidth = 45;

        // Approximate minimum width for each column
        const columnWidths = {
            referenceNo: 130,
            paxName: 150,
            paymentStatus: 140,
            bookingStatus: 140,
            pnr: 100,
            ticketStatus: 130,
            bookingDate: 130,
            fare: 110,
            sector: 140,
            action: 90,
        };

        let availableWidth =
            containerWidth - expanderWidth;

        const visible = [];
        const hidden = [];

        // First column ALWAYS visible
        visible.push(allColumns[0]);

        availableWidth -= columnWidths.referenceNo;

        // Check remaining columns based on actual available width
        allColumns.slice(1).forEach(column => {
            const width = columnWidths[column.id] || 120;

            if (availableWidth >= width) {
                visible.push(column);
                availableWidth -= width;
            } else {
                hidden.push(column);
            }
        });

        setVisibleColumns(visible);
        setHiddenColumns(hidden);
    };

    useEffect(() => {
        calculateResponsiveColumns();

        const resizeObserver = new ResizeObserver(() => {
            calculateResponsiveColumns();
        });

        if (tableWrapperRef.current) {
            resizeObserver.observe(tableWrapperRef.current);
        }

        window.addEventListener(
            "resize",
            calculateResponsiveColumns
        );

        return () => {
            resizeObserver.disconnect();

            window.removeEventListener(
                "resize",
                calculateResponsiveColumns
            );
        };
    }, []);

    const ExpandedComponent = ({ data }) => {
        return (
            <div className="expanded-data">
                {hiddenColumns.map(column => (
                    <div
                        key={column.id}
                        className="expanded-item"
                    >
                        <strong>
                            {column.name}:
                        </strong>

                        <span>
                            {column.cell
                                ? column.cell(data)
                                : column.selector
                                    ? column.selector(data)
                                    : "-"}
                        </span>
                    </div>
                ))}
            </div>
        );
    };


    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">All Transactions</li>

                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href='/Dashboard'>
                                        <img src='/assets/images/back.png' width={30} /> </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* Filters */}
            <section className="wraper">
                <div className="box_shadow mt-14">
                    {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                        <>
                            <div className="row">
                                <div className="col-md-3 mb-1">
                                    <label>Org / Company / legal Entity</label>
                                    <select
                                        className="form-select form-select-solid"
                                        name="organization"
                                        value={filters.organization || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">--Select--</option>
                                        {organizations?.map((org) => (
                                            <option key={org.corporateCode} value={org.parentCorporateCode}>
                                                {org.corporateName} {org.corporateType ? `(${org.corporateType})` : ""}
                                            </option>
                                        ))}
                                    </select>


                                </div>
                                {!hideCompany && (
                                    <div className="col-md-3 mb-1">
                                        <label>Company </label>
                                        <select
                                            className="form-select form-select-solid"
                                            name="company"
                                            value={filters.company ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">--Select--</option>

                                            {company?.map((comp) => (
                                                <option key={comp.corporateCode} value={comp.parentCorporateCode}>
                                                    {comp.corporateName} {comp.corporateType ? `(${comp.corporateType})` : ""}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                {!hidelegalEntity && (
                                    <div className="col-md-3 mb-1 hidelegalEntity">
                                        <label>Legal Entity </label>
                                        <select
                                            className="form-select form-select-solid"
                                            name="legalEntity"
                                            value={filters.legalEntity ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">--Select--</option>
                                            {legalEntity?.map((LE) => (
                                                <option key={LE.corporateCode} value={LE.corporateCode}>
                                                    {LE.corporateName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                            <div className="row">
                                <div className="col-md-3 mb-1">
                                    <label>Corporate Traveller </label>
                                    <select
                                        className="form-select form-select-solid" name="paymentStatus" alue={filters.paymentStatus}
                                        onChange={handleChange}>
                                        <option value="">- All -</option>
                                    </select>
                                </div>


                                <div className="col-md-3 mb-1">
                                    <label>From Date</label>
                                    <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                                </div>
                                <div className="col-md-3 mb-1">
                                    <label>To Date</label>
                                    <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                                </div>
                                <div className="col-md-3 mb-1">
                                    <label>PNR Number</label>
                                    <input
                                        className="form-control form-control-solid"
                                        type="text"
                                        name="pnr"
                                        value={filters.pnr}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Transaction ID */}
                                <div className="col-md-3 mb-1">
                                    <label>Transaction ID</label>
                                    <input
                                        className="form-control form-control-solid"
                                        type="text"
                                        name="transactionId"
                                        value={filters.transactionId}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Booking RefNo */}
                                <div className="col-md-3 mb-1">
                                    <label>Booking RefNo</label>
                                    <input
                                        className="form-control form-control-solid"
                                        type="text"
                                        name="bookingRefNo"
                                        value={filters.bookingRefNo}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Payment Status */}
                                <div className="col-md-3 mb-1">
                                    <label>Payment Status</label>
                                    <select
                                        className="form-select form-select-solid"
                                        name="paymentStatus"
                                        value={filters.paymentStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">- Select -</option>
                                        <option value="Success">Success</option>
                                        <option value="Requested">Requested</option>
                                        <option value="Failure">Failure</option>
                                        <option value="Refunded">Refunded</option>
                                        <option value="UnPaid">UnPaid</option>
                                    </select>
                                </div>

                                {/* Booking Status */}
                                <div className="col-md-3 mb-1">
                                    <label>Booking Status</label>
                                    <select
                                        className="form-select form-select-solid"
                                        name="bookingStatus"
                                        value={filters.bookingStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">- Select -</option>
                                        <option value="Confirmed">Confirmed</option>
                                        <option value="Hold">Hold</option>
                                        <option value="Failure">Failure</option>
                                        <option value="Released">Released</option>
                                        <option value="OnRequest">OnRequest</option>
                                        <option value="Cancelled">Cancelled</option>
                                        <option value="Voided">Voided</option>
                                    </select>
                                </div>

                                {/* Search Button */}
                                <div className="col-md-3 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSearch}
                                        disabled={loading}
                                    >
                                        {loading ? "Loading..." : "Search"}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    {roles?.includes("Corp Travel Manager", "Corp Administrator") && (
                        <div className="row">


                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>PNR Number</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="pnr"
                                    value={filters.pnr}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Transaction ID */}
                            <div className="col-md-3 mb-1">
                                <label>Transaction ID</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="transactionId"
                                    value={filters.transactionId}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Booking RefNo */}
                            <div className="col-md-3 mb-1">
                                <label>Booking RefNo</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Payment Status */}
                            <div className="col-md-3 mb-1">
                                <label>Payment Status</label>
                                <select
                                    className="form-select form-select-solid"
                                    name="paymentStatus"
                                    value={filters.paymentStatus}
                                    onChange={handleChange}
                                >
                                    <option value="">- Select -</option>
                                    <option value="Success">Success</option>
                                    <option value="Requested">Requested</option>
                                    <option value="Failure">Failure</option>
                                    <option value="Refunded">Refunded</option>
                                    <option value="UnPaid">UnPaid</option>
                                </select>
                            </div>

                            {/* Booking Status */}
                            <div className="col-md-3 mb-1">
                                <label>Booking Status</label>
                                <select
                                    className="form-select form-select-solid"
                                    name="bookingStatus"
                                    value={filters.bookingStatus}
                                    onChange={handleChange}
                                >
                                    <option value="">- Select -</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Hold">Hold</option>
                                    <option value="Failure">Failure</option>
                                    <option value="Released">Released</option>
                                    <option value="OnRequest">OnRequest</option>
                                    <option value="Cancelled">Cancelled</option>
                                    <option value="Voided">Voided</option>
                                </select>
                            </div>

                            {/* Search Button */}
                            <div className="col-md-3 mb-3 text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                    {roles?.includes("Corporate Traveller") && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>PNR Number</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="pnr"
                                    value={filters.pnr}
                                    onChange={handleChange}
                                />
                            </div>


                            {/* Search Button */}
                            <div className="col-md-3 mb-3 text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <div className="box_shadow mt-3">
                    <div className="d-flex justify-content-end align-items-center mb-4">
                        <div style={{ width: "320px" }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Ref No, Pax Name, PNR..."
                                value={filterText}
                                onChange={(e) =>
                                    setFilterText(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    <div
                        ref={tableWrapperRef}
                        className="transaction-table-wrapper"
                    >
                        <DataTable
                            columns={visibleColumns}
                            data={filteredItems}
                            progressPending={loading}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            customStyles={customStyles}
                            highlightOnHover
                            responsive
                            persistTableHead
                            noDataComponent="No records found"
                            expandableRows={hiddenColumns.length > 0}
                            expandableRowsComponent={ExpandedComponent}
                            expandOnRowClicked={false}
                            expandableRowsHideExpander={false}
                            expandableIcon={{
                                collapsed: <span className="table-plus-icon">+</span>,
                                expanded: <span className="table-plus-icon">−</span>,
                            }}
                        />
                    </div>
                </div>


            </section>
        </>
    );
};

export default AllTransactions;
